<template>
  <router-link :to="to">
    <img :src="icon" :alt="alt" />
    <slot />
  </router-link>
</template>

<script>
export default {
  props: {
    to: String,
    alt: String,
    icon: String
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
  a {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    color: #1c2e53;
    text-decoration: none;
    box-sizing: border-box;
    padding-top: 18px;

    img {
      height: 23px;
    }

    &.router-link-active,
    &:hover {
      padding-top: 0;
      border-bottom: 0;

      &:before {
        content: "";
        display: block;
        background-color: #f1d85b;
        width: 9px;
        height: 9px;
        border-radius: 9px;
        margin: 0 auto 9px;
      }
    }

    &:after {
      content: "";
      display: block;
      height: 2px;
      width: 0%;
      background-color: #f1d85b;
      transition: width 0.5s ease;
      margin: auto;
    }

    &.router-link-active {
      &:after {
        width: 100%;
      }
    }

    &:hover {
      &:after {
        width: 100%;
      }
    }
  }
}

@media (max-width: 1023px) {
  a {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    color: #1c2e53;
    text-decoration: none;
    box-sizing: border-box;
    padding-top: 20px;
    font-weight: bold;
    img {
      display: none !important;
    }

    &:after {
      display: none !important;
    }
  }
}
</style>
